import React, { useState } from 'react';
import {Box,Typography} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { FileOpen, Remove, TitleRounded } from '@mui/icons-material';

const AnalyzeDialog = ({visible,setVisible,data})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Analyze
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{width:{xs:300,md:450},justifyContent:"center",background:theme.palette.background.default}}>
           <Box textAlign="left">
                <Typography mb={1} mt={1} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
                    Resume description
                </Typography>
                <Typography color="white" ml={1} fontSize={12} sx={{whiteSpace:"pre-wrap"}}>
                    {data?.description}
                </Typography>
                <Typography mb={1} mt={1} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
                    Missing Skills
                </Typography>
                <ol>
                    {data?.missingSkills?.map((item,index)=>(
                        <li key={index} style={{color:"#fff",fontSize:11}}>
                                {item}
                        </li>
                        ))
                    }
                </ol>
                <Typography mb={1} mt={1} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
                    Current Skills
                </Typography>
                <ol style={{textAlign:"left"}}>
                    {data?.matchSkills?.map((item,index)=>(
                        <li key={index} style={{color:"#fff",fontSize:11}}>
                                {item}
                        </li>
                        ))
                    }
                </ol>
           </Box>
		</DialogContent>
	</Dialog>
	)
}

export default AnalyzeDialog;